/* Pickld category index: swap the preview panel on row hover and keyboard focus.
   Every panel is rendered by Liquid; without this file the first one shows.
   Inactive panels are `inert` (and aria-hidden) from the moment they stop being
   the shown one, so Tab can never land on a CTA inside a panel that is fading out.

   Below 750px (no stage) the rows come alive instead (2026-10-18, Ben: "as I hover
   over these on mobile, nothing happens"). One row at a time is LIT (.is-lit, and
   .has-lit on the list, styled in section-pickld-category-index.css): the row under
   a mouse, else the row under a finger while it presses, else, on a touch-only
   screen, the row nearest the middle of the viewport while the list crosses it.
   A tap still just follows the link. Plain scroll listener, read in one animation
   frame, no IntersectionObserver: it costs one rect read per frame and cannot be
   silenced by a browser that throttles observers. */
(function () {
  function init(root) {
    if (root.hasAttribute('data-cx-ready')) return;
    root.setAttribute('data-cx-ready', '');
    var rows = root.querySelectorAll('.pickld-cx__row');
    var panels = root.querySelectorAll('.pickld-cx__panel');
    var cur = null;
    /* Panels after the first carry their pictures as data-cx-src and data-cx-srcset
       (sections/pickld-category-index.liquid) so a hidden preview downloads nothing.
       Moved into place once, the first time the panel is about to show. srcset first,
       so the browser never fetches the src fallback and then a better candidate. */
    function load(panel) {
      if (panel.hasAttribute('data-cx-loaded')) return;
      panel.setAttribute('data-cx-loaded', '');
      var imgs = panel.querySelectorAll('img[data-cx-src]');
      for (var m = 0; m < imgs.length; m++) {
        var img = imgs[m];
        var set = img.getAttribute('data-cx-srcset');
        if (set) img.setAttribute('srcset', set);
        img.setAttribute('src', img.getAttribute('data-cx-src'));
        img.removeAttribute('data-cx-srcset');
        img.removeAttribute('data-cx-src');
      }
    }
    function show(k) {
      if (k === cur) return;
      cur = k;
      for (var i = 0; i < rows.length; i++) {
        rows[i].classList.toggle('is-on', rows[i].getAttribute('data-cx-k') === k);
      }
      for (var j = 0; j < panels.length; j++) {
        var on = panels[j].getAttribute('data-cx-k') === k;
        if (on) load(panels[j]);
        panels[j].classList.toggle('is-on', on);
        panels[j].inert = !on;
        if (on) { panels[j].removeAttribute('aria-hidden'); panels[j].removeAttribute('inert'); }
        else { panels[j].setAttribute('aria-hidden', 'true'); panels[j].setAttribute('inert', ''); }
      }
    }
    root.pickldCxShow = show;
    for (var r = 0; r < rows.length; r++) {
      (function (row) {
        var k = row.getAttribute('data-cx-k');
        row.addEventListener('mouseenter', function () { show(k); });
        row.addEventListener('focus', function () { show(k); });
      })(rows[r]);
    }
    if (rows.length) cur = rows[0].getAttribute('data-cx-k');
    alive(root, rows);
  }

  /* ---------- Phone: the lit row ---------- */
  var mqNarrow = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var mqTouchOnly = window.matchMedia ? window.matchMedia('(hover: none)') : null;
  function onChange(mq, fn) {
    if (!mq) return;
    if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn);
  }
  function alive(root, rows) {
    var list = root.querySelector('.pickld-cx__list');
    if (!list || !rows.length || !mqNarrow) return;
    var hoverRow = null, pressRow = null, centreRow = null, lit = null, pressTimer = 0, ticking = false;
    function apply() {
      var next = mqNarrow.matches ? (pressRow || hoverRow || centreRow) : null;
      if (next === lit) return;
      if (lit) lit.classList.remove('is-lit');
      lit = next;
      if (lit) lit.classList.add('is-lit');
      list.classList.toggle('has-lit', !!lit);
    }
    function centre() {
      ticking = false;
      centreRow = null;
      if (mqNarrow.matches && mqTouchOnly && mqTouchOnly.matches) {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var mid = vh / 2, band = Math.max(48, vh * 0.12);
        var box = list.getBoundingClientRect();
        if (box.bottom > mid - band && box.top < mid + band) {
          var best = null, bestD = Infinity;
          for (var i = 0; i < rows.length; i++) {
            var r = rows[i].getBoundingClientRect();
            var d = Math.abs((r.top + r.bottom) / 2 - mid);
            if (d < bestD) { bestD = d; best = rows[i]; }
          }
          if (best && bestD <= band) centreRow = best;
        }
      }
      apply();
    }
    function queue() { if (!ticking) { ticking = true; window.requestAnimationFrame(centre); } }
    function release() {
      clearTimeout(pressTimer);
      /* Hold the lift a beat after the finger lifts, so a tap that navigates still shows it. */
      pressTimer = setTimeout(function () { pressRow = null; apply(); }, 450);
    }
    for (var r = 0; r < rows.length; r++) {
      (function (row) {
        row.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' || e.pointerType === 'pen') { hoverRow = row; apply(); } });
        row.addEventListener('pointerleave', function (e) { if (hoverRow === row && e.pointerType !== 'touch') { hoverRow = null; apply(); } });
        row.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') { clearTimeout(pressTimer); pressRow = row; apply(); } });
        row.addEventListener('pointerup', function (e) { if (e.pointerType === 'touch' && pressRow === row) release(); });
        /* pointercancel: the finger started a scroll, so this was not a press. */
        row.addEventListener('pointercancel', function () { if (pressRow === row) { clearTimeout(pressTimer); pressRow = null; apply(); } });
      })(rows[r]);
    }
    /* iOS only paints :active (the no-script-style fallback) when a touchstart listener exists. */
    list.addEventListener('touchstart', function () {}, { passive: true });
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    onChange(mqNarrow, queue);
    onChange(mqTouchOnly, queue);
    /* Back from the collection page (bfcache): drop a press that never released. */
    window.addEventListener('pageshow', function () { clearTimeout(pressTimer); pressRow = null; queue(); });
    queue();
  }
  function all() {
    var roots = document.querySelectorAll('[data-pickld-cx-index]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  /* Theme editor: re-bind when the section is re-rendered, and show the panel of
     the block Ben selects in the sidebar (the row carries block.shopify_attributes). */
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:block:select', function (e) {
    var row = e.target && e.target.closest ? e.target.closest('.pickld-cx__row') : null;
    if (!row) return;
    var root = row.closest('[data-pickld-cx-index]');
    if (!root) return;
    init(root);
    if (root.pickldCxShow) root.pickldCxShow(row.getAttribute('data-cx-k'));
  });
})();
